import { render, staticRenderFns } from "./achievementModule.vue?vue&type=template&id=f2627ab2&scoped=true&"
import script from "./achievementModule.vue?vue&type=script&lang=js&"
export * from "./achievementModule.vue?vue&type=script&lang=js&"
import style0 from "./achievementModule.vue?vue&type=style&index=0&id=f2627ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2627ab2",
  null
  
)

export default component.exports